import { Client, Currency } from '../../../pure-js/types/GrooverTypes'
import { DEFAULT_CURRENCY, getCurrencyForClient } from '../../../pure-js/libs/currencyHelper'

export const useCurrency = (client: Client | undefined): Currency => {
  if (!client) return DEFAULT_CURRENCY
  return getCurrencyForClient(client)
}
